let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9gqcE")).then(() => parcelRequire('3hbTz'));